import ReduxProvider from './components/topLevel/ReduxProvider';

const App = () => {
  return (
   <ReduxProvider />
  );
}

export default App;
